import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/drum';
import { volumeCovers } from '../data/volumeCovers';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-277" data-mp="pxf998k9z1wr">
      <div className="mx-auto max-w-6xl" data-id="element-278" data-mp="b55169x11rrv">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-279" data-mp="fwwkq0hrmx8i">
          What’s inside <em className="text-red-700" data-id="element-280" data-mp="27b4uyz9iy4p">DRUM READY™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-281" data-mp="741jrizbznoj">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-282" data-mp="3od84vx139p7i">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-283" data-mp="3tbjfwb34e5rb">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumes" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-284" data-mp="3cw0licmevsmi">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-285" data-mp="3ht0rknj9gvdm" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-286" data-mp="2aenjp7r98z6r">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-287" data-mp="26edfo0n0wiuj">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-288" data-mp="9dhadaiggpmu">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-289" data-mp="j2hcv3w6235s">
          <AnimatePresence mode="wait" initial={false} data-id="element-290" data-mp="o1kjutvpijge">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-291" data-mp="3mk9bv28pzndh">
              <div className="lg:col-span-5" data-id="element-292" data-mp="599m1efwtbp5">
                {volumeCovers[active] && <img src={volumeCovers[active]} alt={`${volume.number} cover – ${volume.title}`} loading="lazy" className="mb-6 w-40 rounded-lg border border-slate-900/10 bg-white shadow-xl shadow-slate-900/15 sm:w-48" data-id="element-293" data-mp="1br6f568ykej4" />}
                <p className="text-sm font-semibold text-red-700" data-id="element-294" data-mp="31awof5bhn1a2">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-295" data-mp="2rih6u943sepp">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-296" data-mp="2miw6pvd760be">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-297" data-mp="2hlvvz75ek9dy">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-298" data-mp="2dig3mn0d8v72">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-299" data-mp="28k4t0a28ygns">Includes</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-300" data-mp="28m8w4psbnbn0">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-301" data-mp="23n5xpo6uk3o0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-302" data-mp="6qfbzoh7csml" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-303" data-mp="2vjk9sfb6ea7x">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-304" data-mp="2lnquio62o2mg">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-305" data-mp="2qoej736tw7di">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-306" data-mp="2bw4g6iyftnfh">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-307" data-mp="2gonop1i9psdf">
              What makes DRUM READY™ different?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-308" data-mp="27w3pnzy2dls2">
              A whole drum studio year – organized and ready to teach.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-309" data-mp="1t15vr2n9oo8v">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-310" data-mp="1ecmlugfde1cn">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-311" data-mp="1aaixir7lr29y" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-312" data-mp="1oaai5asmjgwx">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-313" data-mp="1jb7cbo4tl6nw">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}